import {Dropdown} from "primereact/dropdown"
import {Skeleton} from "primereact/skeleton"
import {useEffect, useMemo, useState} from "react"

import FilterMultiSelect from "../components/FilterMultiSelect"
import SubHeader from "../components/SubHeader"
import OrienteeCardSummary from "./OrienteeCardSummary"
import useSWR from "swr"
import {bulkFilter, fetcherGet} from "../utilities/general"
import {useNavigate} from "react-router-dom"

const SORT_OPTIONS = [
    {label: "Alphabetically (A-Z)", value: "name"},
    {label: "Hire Date (Most Recent-Oldest)", value: "hire_date"},
]

const timestamp = (value) => {
    const parsed = Date.parse(value)
    return Number.isFinite(parsed) ? parsed : 0
}

const EducatorOnboarding = () => {
    const {data: orientees, isLoading} = useSWR("/orientees/onboarding", fetcherGet, {fallbackData: []})
    const navigate = useNavigate()

    const [unitFilter, setUnitFilter] = useState([])
    const [sortBy, setSortBy] = useState("name")

    useEffect(() => {
        document.title = "My Team"
    }, [])

    const completeOnboarding = (orientation_id) => {
        navigate(`/educator-onboarding/${orientation_id}`)
    }

    const unitOptions = useMemo(
        () => [...new Set(orientees.map((o) => o.unit_name))].filter(Boolean).sort().map((unit) => ({label: unit, value: unit})),
        [orientees],
    )

    const visibleOrientees = useMemo(() => {
        const filtered = bulkFilter(orientees, [["unit_name", unitFilter, "includes"]])
        return [...filtered].sort((a, b) =>
            sortBy === "hire_date"
                ? timestamp(b.hire_date) - timestamp(a.hire_date)
                : (a.name || "").localeCompare(b.name || ""),
        )
    }, [orientees, unitFilter, sortBy])

    return (
        <>
            <SubHeader title1="" title2="Onboard Orientees" icon="fa-list-check" children={null} />
            <div className="container d-flex flex-column">
                {isLoading && (
                    <div className="card p-8 mt-6">
                        <Skeleton width="100%" height="10rem" />
                    </div>
                )}
                {!isLoading && orientees.length === 0 && (
                    <div className="card p-8 mt-6">No active employees found to onboard at this time</div>
                )}
                {!isLoading && orientees.length > 0 && (
                    <>
                        <div className="card mt-8 mx-8 border border-gray-400">
                            <div className="card-body py-4 px-4 px-md-8">
                                <div className="row g-8">
                                    <FilterMultiSelect
                                        inputId="unit"
                                        label="Unit"
                                        value={unitFilter}
                                        options={unitOptions}
                                        onChange={setUnitFilter}
                                    />
                                    <div className="col-lg-3 col-md-6">
                                        <div className="d-flex flex-column">
                                            <label htmlFor="sort-by" className="fs-6 form-label fw-bold text-dark">
                                                Sort By
                                            </label>
                                            <Dropdown
                                                inputId="sort-by"
                                                value={sortBy}
                                                options={SORT_OPTIONS}
                                                onChange={(event) => setSortBy(event.value)}
                                                className="w-100"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {visibleOrientees.length === 0 && (
                            <div className="card mt-4">
                                <div className="card-body text-center fw-semibold text-gray-600 py-10">
                                    No orientees match your filters.
                                </div>
                            </div>
                        )}
                        {visibleOrientees.map((orientation, index) => (
                            <OrienteeCardSummary
                                orientee={orientation}
                                key={index + orientation.name}
                                onCompleteOnboarding={() => completeOnboarding(orientation.orientation_id)}
                            />
                        ))}
                    </>
                )}
            </div>
        </>
    )
}

export default EducatorOnboarding
